import HeroSection from "../../components/UserComponents/heroSection";
import PageHeader from "../../components/common/PageHeader";

export default function RefundCancellation() {
  return (
    <div>
      <HeroSection
        title="Refund & Cancellation Policy"
        description="Understand our cancellation and refund rules."
        showSearchBar={false}
      />

      <div className="max-w-4xl mx-auto px-4 py-10">
        <PageHeader title="Refund & Cancellation Policy" />

        <div className="mt-6 space-y-4 text-md text-gray-600 leading-relaxed">
          <p>
            Unless explicitly stated otherwise on an experience listing,
            bookings are fully refundable if cancelled at least seven (7) days
            prior to the scheduled start time.
          </p>

          <p>
            Vendors may publish a different cancellation policy, which must be
            clearly disclosed on the listing and at checkout and will govern
            that booking.
          </p>

          <p>
            Cancellations made fewer than seven (7) days prior and no-shows are
            non-refundable unless required by law or approved by the Vendor.
          </p>

          <p>
            If a Vendor cancels, users will receive a full refund or
            rescheduling options.
          </p>

          <p>
            Cancellations due to safety concerns or severe weather will receive
            refund or reschedule options.
          </p>
        </div>
      </div>
    </div>
  );
}
